import { render } from "./TableV2.vue?vue&type=template&id=7a4d9b8e"
import script from "./TableV2.vue?vue&type=script&lang=js"
export * from "./TableV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__